// extracted by mini-css-extract-plugin
export default {"confirm":"confirm-oHFk","description":"description-MIng"};